import { useState } from "react";

const testimonials = [
  {
    quote: "I used to spend hours comparing outfits across different stores. With Pandabuy Spreadsheet, I find the best deals across all categories in minutes. It completely changed how I shop for streetwear.",
    author: "Alex",
    role: "Vintage Collector",
    image: "https://readdy.ai/api/search-image?query=Casual%20portrait%20of%20stylish%20young%20man%20with%20confident%20expression%20in%20minimal%20cream%20studio%2C%20soft%20natural%20daylight%2C%20editorial%20portrait%20photography%2C%20warm%20neutral%20earth%20tones%2C%20high%20detail%2C%20authentic%20natural%20pose&width=800&height=1000&seq=testimonial-v2-01&orientation=portrait",
  },
  {
    quote: "The spreadsheet format makes comparing prices so intuitive. I've saved hundreds on jackets and sneakers just by checking the weekly updates. Honestly the best fashion tool I have found online.",
    author: "Maya",
    role: "Streetwear Blogger",
    image: "https://readdy.ai/api/search-image?query=Natural%20portrait%20of%20young%20woman%20with%20warm%20smile%20in%20casual%20chic%20outfit%20against%20clean%20cream%20wall%2C%20soft%20studio%20lighting%2C%20editorial%20portrait%20photography%2C%20warm%20neutral%20aesthetic%2C%20high%20detail%2C%20relaxed%20genuine%20expression&width=800&height=1000&seq=testimonial-v2-02&orientation=portrait",
  },
  {
    quote: "As someone who tracks luxury fashion alternatives, the Pandabuy Sheet is essential for my workflow. The category breakdowns save me so much research time every single week.",
    author: "Jordan",
    role: "Fashion Researcher",
    image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20person%20in%20minimalist%20outfit%20leaning%20against%20white%20wall%2C%20confident%20yet%20approachable%20expression%2C%20soft%20studio%20lighting%2C%20editorial%20portrait%2C%20warm%20neutral%20tones%2C%20high%20detail%2C%20clean%20modern%20aesthetic&width=800&height=1000&seq=testimonial-v2-03&orientation=portrait",
  },
];

export default function SocialProofSection() {
  const [current, setCurrent] = useState(0);
  const t = testimonials[current];

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-16">
          <div className="lg:w-[40%]">
            <div className="rounded-2xl overflow-hidden aspect-[4/5] max-h-[500px]">
              <img
                src={t.image}
                alt={`${t.author} - Pandabuy Sheet testimonial`}
                title={`${t.author} - ${t.role}`}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:w-[60%] flex flex-col justify-center">
            <span className="text-xs md:text-sm text-accent-600 font-medium tracking-wide mb-4">(Verified User)</span>
            <p className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 mb-2">
              Join 10,000+
            </p>
            <p className="text-3xl md:text-5xl font-heading text-foreground-300 mb-8">
              Fashion Enthusiasts
            </p>

            <blockquote className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-xl">
              &ldquo;{t.quote}&rdquo;
            </blockquote>

            <p className="text-base font-semibold text-foreground-900 mb-10">
              &mdash; {t.author}, <span className="font-normal text-foreground-500">{t.role}</span>
            </p>

            <div className="flex items-center gap-3">
              <button
                onClick={prev}
                className="w-10 h-10 rounded-full border border-background-300 flex items-center justify-center text-foreground-500 hover:text-foreground-900 hover:border-foreground-400 cursor-pointer transition-colors"
                aria-label="Previous testimonial"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={next}
                className="w-10 h-10 rounded-full bg-foreground-900 flex items-center justify-center text-white hover:bg-foreground-800 cursor-pointer transition-colors"
                aria-label="Next testimonial"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
              <span className="text-xs text-foreground-400 ml-2">
                {current + 1} / {testimonials.length}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}